import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FaChevronDown } from 'react-icons/fa6';

import { OptionChain } from 'constants/opc';
import classNames from 'styles/utils/classNames';
import { formatExpirationDate, getDaysToExpiration } from 'utils/shared/time/formatExpirationDate';

interface DateDropdownProps {
  chain: OptionChain;
  ticker: string;
  value: string;
  setValue: (entry: {
    e?: string | undefined;
    ey?: number | undefined;
    em?: number | undefined;
    ed?: number | undefined;
    c?:
      | {
          [key: string]: {
            c?:
              | {
                  b?: number | undefined;
                  a?: number | undefined;
                  av?: number | undefined;
                  bv?: number | undefined;
                }
              | undefined;
            p?:
              | {
                  b?: number | undefined;
                  a?: number | undefined;
                  av?: number | undefined;
                  bv?: number | undefined;
                }
              | undefined;
          };
        }
      | undefined;
  }) => void;
  defaultValue: string;
}

export default function DateDropdown({ chain, ticker, value, setValue }: DateDropdownProps) {
  // const [value, setValue] = useState(defaultValue);

  return (
    <Menu as="div" className="relative block w-full text-left">
      <div>
        <Menu.Button className="flex w-full items-center justify-between rounded border border-palette-border bg-palette-black-1 py-1 pl-2 pr-2">
          {formatExpirationDate(value)}
          <FaChevronDown className="h-2.5 w-2.5 text-gray-400" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 max-h-80 w-56 origin-top-right divide-y divide-gray-100 overflow-auto rounded-md border border-palette-border bg-palette-black-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {chain?.[ticker]?.entries
              ?.filter((entry) => getDaysToExpiration(`${entry.ey}-${entry.em}-${entry.ed}`) >= 0)
              .map((entry, index) => (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <button
                      className={classNames(
                        active ? 'bg-brand-primary text-white' : 'text-white',
                        'block w-full px-4 py-2 text-left text-sm',
                      )}
                      onClick={() => setValue(entry)}
                    >
                      {formatExpirationDate(`${entry.ey}-${entry.em}-${entry.ed}`)}
                    </button>
                  )}
                </Menu.Item>
              ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
